<template>
  <div class="overflow" style="padding: 30px;height: 100%;overflow-y: auto">
    <div class="settingDiv">
      <div style="color: rgb(7, 230, 248);">
        短信通知配置
        <a type="text" size="mini" @touchstart="updateSystemParamter('gatewayNoteNotification')"  @click="updateSystemParamter('gatewayNoteNotification')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 40px;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">阿里云短信：</el-col>
        <el-col v-if="alibaba_cloud_SMS.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;"> 未启用 </el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
            <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
              <el-col :xl="3" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> ID: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{alibaba_cloud_SMS_ID.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="3" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 密钥: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{alibaba_cloud_SMS_key.val1}} </el-col>
            </el-col>
          </el-col>
        </el-col>
      </el-row>

        <el-row style="margin-left: 1%; margin-top: 80px;">
          <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">串口短信：</el-col>
          <el-col v-if="serial_SMS.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
            <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
          </el-col>
          <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
            <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
              <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>

              <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
                <el-col :xl="3" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> COM口: </el-col>
                <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{serial_SMS_COM.val1}} </el-col>
              </el-col>
              <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
                <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 中心号码: </el-col>
                <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{center_number.val1}} </el-col>
              </el-col>
              <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
                <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 发送号码: </el-col>
                <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{sending_number.val1}} </el-col>
              </el-col>
            </el-col>
          </el-col>
        </el-row>

        <el-row style="margin-left: 1%; margin-top: 80px;">
          <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">主机短信：</el-col>
          <el-col v-if="host_SMS.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
            <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
          </el-col>
          <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
            <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
              <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>

              <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 20px;" v-for="item in shortMessageNoticeSpaceHostNameList" :key="item.hostName">
                <span class="text-grey">空间：</span>
                <span v-if="item.inverse">除{{item.spaceName}}外</span>
                <span v-else>{{item.spaceName}}</span>
                 &nbsp;&nbsp; — &nbsp;&nbsp; 发送主机：{{ item.hostName }}
              </el-col>
            </el-col>
          </el-col>
        </el-row>

      <el-row style="margin-left: 1%; margin-top: 80px;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">自定义通道：</el-col>
        <el-col v-if="custom_SMS.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;"> 未启用 </el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
            <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
              <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 通道地址: </el-col>
              <el-col :xl="17" :lg="17" :md="17" :sm="17" :xs="17"> {{custom_url.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 请求方式: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{custom_method.val1 === 'POST'?custom_method.val1+' ('+custom_postRequestWay.val1+')':custom_method.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 编码格式: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{custom_parameterFormat.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 固定参数: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{custom_parameter.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="4" :lg="4" :md="5" :sm="6" :xs="15" class="text-grey"> 结果key: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="9"> {{custom_resultKey.val1}} </el-col>
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>

    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        邮件通知配置
        <a type="text" size="mini" @touchstart="updateSystemParamter('emailNotification')" @click="updateSystemParamter('emailNotification')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">邮件服务器：</el-col>
        <el-col v-if="mail_server.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
            <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>

            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="23" class="text-grey"> 服务器地址: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="12" :xs="23"> {{mail_SMTP.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="6" class="text-grey"> SSL: </el-col>
              <el-col v-if="mail_SSL.val1 == 'false'" :xl="15" :lg="15" :md="15" :sm="13" :xs="18">
                <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
                <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
              </el-col>
              <el-col v-else :xl="15" :lg="15" :md="15" :sm="13" :xs="18">
                <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
                <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
                  <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>
                </el-col>
              </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;" v-if="mail_SSL.val1 == 'true'">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="12" class="text-grey"> SSL端口: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="12"> {{mail_SSL_port.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="8" class="text-grey"> 端口: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="16"> {{mail_port.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="23" class="text-grey"> 发送邮箱: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="23"> {{mail_send_email.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23"  style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="13" class="text-grey"> 发送用户名: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="11"> {{mail_send_userName.val1}} </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="11" class="text-grey"> 验证密码: </el-col>
              <el-col v-if="mail_verification.val1 == 'false'" :xl="15" :lg="15" :md="15" :sm="13" :xs="23">
                <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
                <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
              </el-col>
              <el-col v-else :xl="15" :lg="15" :md="15" :sm="13" :xs="13">
                <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
                <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
                  <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>
                </el-col>
              </el-col>
            </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" v-if="mail_verification.val1 == 'true'" style="margin-top: 10px;">
              <el-col :xl="7" :lg="7" :md="7" :sm="10" :xs="8" class="text-grey"> 密码: </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="13" :xs="16"> {{mail_password.val1}} </el-col>
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>

    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        电话通知配置
        <a type="text" size="mini" @touchstart="updateSystemParamter('gatewayPhoneNotification')" @click="updateSystemParamter('gatewayPhoneNotification')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">主机电话：</el-col>
        <el-col v-if="host_phone.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="14" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
            <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>
            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 20px;" v-for="item in telephoneNoticeSpaceHostNameList" :key="item.hostName">
              <span class="text-grey">空间：</span>
              <span v-if="item.inverse">除{{item.spaceName}}外</span>
              <span v-else>{{item.spaceName}}</span>
              &nbsp;&nbsp; — &nbsp;&nbsp; 发送主机：{{ item.hostName }}
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>

    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        声光通知配置
        <a type="text" size="mini" @touchstart="updateSystemParamter('gatewaySoundLightNotification')" @click="updateSystemParamter('gatewaySoundLightNotification')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">主机声光：</el-col>
        <el-col v-if="host_acousto_optic.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="14" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">
            <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="20"> 已启用 </el-col>

            <el-col :xl="23" :lg="23" :md="23" :sm="23" :xs="23" style="margin-top: 20px;" v-for="item in acoustoOpticNoticeSpaceHostNameList" :key="item.hostName">
              <span class="text-grey">空间：</span>
              <span v-if="item.inverse">除{{item.spaceName}}外</span>
              <span v-else>{{item.spaceName}}</span>
               &nbsp;&nbsp; — &nbsp;&nbsp; 发送主机：{{ item.hostName }}
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>


    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        声音通知配置
        <a type="text" size="mini" @touchstart="updateSystemParamter('voiceWarningNotification')" @click="updateSystemParamter('voiceWarningNotification')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="7">声音通知：</el-col>
        <el-col v-if="voice_alarm.val1 == 'false'" :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col v-else :xl="20" :lg="18" :md="18" :sm="18" :xs="17">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">已启用</el-col>
        </el-col>
      </el-row>
    </div>


    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        告警推送配置
        <a @touchstart="updateSystemParamter('alarmNotification')" @click="updateSystemParamter('alarmNotification')" size="mini"
           style="color:#299FFB; cursor: pointer; float: right;"
           type="text">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="2" :md="3" :sm="4" :xl="2" :xs="7">告警推送：</el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="17" v-if="!alarmNotification.val1">
          <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="8" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="17" v-else>
          <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="14" :xs="15" style="margin-left: 2%;">
            <el-col :lg="20" :md="20" :sm="20" :xl="20" :xs="20"> 已启用</el-col>

            <el-col :lg="23" :md="23" :sm="23" :xl="23" :xs="23" style="margin-top: 20px;">
              <span class="text-grey">推送地址：</span>
              {{ alarmNotification.val2 }}
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>

    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        告警推送企业微信配置
        <a @touchstart="updateSystemParamter('alarmWechatNotification')" @click="updateSystemParamter('alarmWechatNotification')" size="mini"
           style="color:#299FFB; cursor: pointer; float: right;"
           type="text">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="2" :md="3" :sm="4" :xl="2" :xs="7">企业微信推送：</el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="17" v-if="!alarmWechatNotification.val1">
          <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="8" :xs="15" style="margin-left: 2%;">未启用</el-col>
        </el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="17" v-else>
          <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="14" :xs="15" style="margin-left: 2%;">
            <el-col :lg="20" :md="20" :sm="20" :xl="20" :xs="20"> 已启用</el-col>

            <el-col :lg="23" :md="23" :sm="23" :xl="23" :xs="23" style="margin-top: 20px;">
              <span class="text-grey">推送地址：</span>
              {{ alarmWechatNotification.val2 }}
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>


    <!--    弹出窗-->
    <dialog-component
      :dialog-title="title"
      :dialogVisible.sync="notificationConfigurationDialogVisible"
      @dialogClose="closeDialog"
      center
      :closeClick="false"
      :width="width">
      <div slot="content">

        <!--        短信通知配置-->
        <short-message-notice v-if="shortMessageNoticeVoice"
                               :alibabaCloudSMSIDData="edit_alibaba_cloud_SMS_ID"
                               :alibabaCloudSMSKeyData="edit_alibaba_cloud_SMS_key"
                               :serialSMSCOMData="edit_serial_SMS_COM"
                               :centerNumberData="edit_center_number"
                               :sendingNumberData="edit_sending_number"
                               :shortMessageNoticeData="shortMessageNoticeData"
                               :type="noticeType"
                               :spaceHostList="shortMessageNoticeSpaceHostList"
                               :wholeSpace="shortMessageNoticeWholeSpace"
                               :gatewaySn="shortMessageNoticeGatewaySn"
                               :spaceList="spaceList"
                               :gatewayList="gatewayList"
                               :customUrl="edit_custom_url"
                               :customMethod="edit_custom_method"
                               :customParameter="edit_custom_parameter"
                               :customResultKey="edit_custom_resultKey"
                               :customPostRequestWay="edit_custom_postRequestWay"
                               :customParameterFormat="edit_custom_parameterFormat"
                               @setWholeSpace="(data) => this.shortMessageNoticeWholeSpace = data"
                               @setGatewaySn="(data) => this.shortMessageNoticeGatewaySn = data"/>
<!--        邮箱通知配置-->
        <email-notification-notice v-if="emailNotificationNoticeVoice"
                                   :mailSMTPData="edit_mail_SMTP"
                                   :mailSSLPortData="edit_mail_SSL_port"
                                   :mailPortData="edit_mail_port"
                                   :mailSendEmailData="edit_mail_send_email"
                                   :mailSendUserNameData="edit_mail_send_userName"
                                   :mailPasswordData="edit_mail_password"
                                   :emailNotificationNoticeData="emailNotificationNoticeData"/>

      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 50px; margin-bottom: 15px;">
        <el-button @touchstart="closeDialog" @click="closeDialog" size="mini">关 闭</el-button>
        <el-button @touchstart="commitSystematic" @click="commitSystematic" size="mini" type="primary">保 存</el-button>
      </div>
    </dialog-component>

    <function-dialog-component :close-click="false"
                               :dialog-title="title"
                               :dialogVisible.sync="notificationConfigurationFunctionDialogVisible"
                               @dialogClose="closeDialog"
                               center
                               :width="width">
      <div slot="content">
        <!--        电话通知配置-->
        <telephone-notice v-if="telephoneNoticeVoice"
                          :type="noticeType"
                          :spaceHostList="telephoneNoticeSpaceHostList"
                          :wholeSpace="telephoneNoticeWholeSpace"
                          :gatewaySn="telephoneNoticeGatewaySn"
                          :spaceList="spaceList"
                          :gatewayList="gatewayList"
                          @setWholeSpace="(data) => this.telephoneNoticeWholeSpace = data"
                          @setGatewaySn="(data) => this.telephoneNoticeGatewaySn = data"
                          :telephoneNoticeData="telephoneNoticeData"/>

        <!--        声光通知配置-->
        <acousto-optic-notice v-if="acoustoOpticNoticeVoice"
                              :type="noticeType"
                              :spaceHostList="acoustoOpticNoticeSpaceHostList"
                              :wholeSpace="acoustoOpticNoticeWholeSpace"
                              :gatewaySn="acoustoOpticNoticeGatewaySn"
                              :spaceList="spaceList"
                              :gatewayList="gatewayList"
                              @setWholeSpace="(data) => this.acoustoOpticNoticeWholeSpace = data"
                              @setGatewaySn="(data) => this.acoustoOpticNoticeGatewaySn = data"
                              :acoustoOpticNoticeData="acoustoOpticNoticeData"/>
        <!--        声音通知配置-->
        <voice-alarm v-if="voiceAlarmVoice"
                     :voiceAlarmData="voiceAlarmData"/>

        <alarm-notification :alarmNotification="dialogData"
                            @receiveData="receiveData"
                            v-if="type === 'alarmNotification'"></alarm-notification>

        <alarm-wechat-notification :alarmWechatNotification="dialogWechatData"
                            @receiveData="receiveWechatData"
                            v-if="type === 'alarmWechatNotification'"></alarm-wechat-notification>

      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 50px; margin-bottom: 15px;">
        <el-button @touchstart="closeDialog" @click="closeDialog" size="mini">关 闭</el-button>
        <el-button @touchstart="commitSystematic" @click="commitSystematic" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import voiceAlarm from "@/views/basic_operations/sys_setting/notification_configuration/voiceAlarm";
import {
  getSystematicByCodes,
  getSystematicByParentCodes,
  preservationAndQuerySystematic,
  saveOrUpdateSystematic
} from "@/network/systematic";
import ShortMessageNotice from "@/views/basic_operations/sys_setting/notification_configuration/ShortMessageNotice";
import EmailNotificationNotice
  from "@/views/basic_operations/sys_setting/notification_configuration/EmailNotificationNotice";
import TelephoneNotice from "@/views/basic_operations/sys_setting/notification_configuration/TelephoneNotice";
import {gatewayNoticeList, saveGatewayNotice} from "@/network/device-gateway-notice";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import {gatewayList} from "@/network/device-gateway";
import AcoustoOpticNotice from "@/views/basic_operations/sys_setting/notification_configuration/AcoustoOpticNotice";
import DialogComponent from "@/components/DialogComponent";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import AlarmNotification from "@/views/basic_operations/sys_setting/notification_configuration/AlarmNotification";
import AlarmWechatNotification from "@/views/basic_operations/sys_setting/notification_configuration/AlarmWechatNotification";

export default {
  name: "NotificationConfiguration",
  inject: ['overflow'],
  components: {
    FunctionDialogComponent,
    DialogComponent,
    voiceAlarm,
    ShortMessageNotice,
    EmailNotificationNotice,
    TelephoneNotice,
    AcoustoOpticNotice,
    AlarmNotification,
    AlarmWechatNotification
  },
  data() {
    return {
      notificationConfiguration: [], //系统配置数据

      alibaba_cloud_SMS: {}, //阿里云短信
      alibaba_cloud_SMS_ID: {},  //阿里云短信ID
      alibaba_cloud_SMS_key: {}, //阿里云短信密钥
      serial_SMS: {},   //串口短信
      serial_SMS_COM: {}, //COM口
      center_number: {}, //中心号码
      sending_number: {}, //发送号码
      host_SMS: {}, //主机短信

      mail_server: {}, //邮件服务器
      mail_SMTP: {}, //邮件服务器地址
      mail_SSL: {}, //SSL
      mail_SSL_port: {}, //SSL端口
      mail_verification: {}, //验证
      mail_port: {}, //邮件端口
      mail_send_email: {}, //发送邮箱
      mail_send_userName: {}, //发送用户名
      mail_password: {}, //密码

      custom_SMS:{}, //自定义通道
      custom_url:{}, //自定义通道地址
      custom_method:{}, //自定义请求方式
      custom_parameter:{}, //自定义固定参数
      custom_resultKey:{}, //自定义结果key
      custom_postRequestWay:{}, //自定义post请求类型
      custom_parameterFormat:{}, //自定义入参编码格式


      host_phone: {}, //主机电话

      host_acousto_optic: {}, //主机声光

      voice_alarm: {}, //声音通知配置

      edit_alibaba_cloud_SMS:{}, //编辑阿里云短信
      edit_alibaba_cloud_SMS_ID:{},  //编辑阿里云短信ID
      edit_alibaba_cloud_SMS_key:{}, //编辑阿里云短信密钥
      edit_serial_SMS: {},   //编辑串口短信
      edit_serial_SMS_COM: {}, //编辑COM口
      edit_center_number: {}, //编辑中心号码
      edit_sending_number: {}, //编辑发送号码
      edit_host_SMS: {}, //编辑主机短信
      edit_custom:{},// 编辑自定义通道

      edit_mail_server: {}, //编辑邮件服务器
      edit_mail_SMTP: {}, //编辑邮件服务器地址
      edit_mail_SSL: {}, //SSL
      edit_mail_SSL_port: {}, //SSL端口
      edit_mail_verification: {}, //验证
      edit_mail_port: {}, //编辑邮件端口
      edit_mail_send_email: {}, //编辑发送邮箱
      edit_mail_send_userName: {}, //编辑发送用户名
      edit_mail_password: {}, //编辑密码

      edit_host_phone: {}, //编辑主机电话

      edit_host_acousto_optic: {}, //编辑主机声光

      edit_voice_alarm: {}, //编辑声音通知配置

      edit_custom_url:{},//编辑自定义通道地址
      edit_custom_method:{},//编辑自定义请求方式
      edit_custom_parameter:{},//编辑自定义固定参数
      edit_custom_resultKey:{},//编辑自定义结果Key
      edit_custom_postRequestWay:{},//编辑自定义POST请求类型
      edit_custom_parameterFormat:{},//编辑自定义入参编码格式


      hostConfigurationNoticeData: {    //主机通知状态值
        acoustoOpticNoticeVal:false,    //声光通知状态值
        shortMessagNoticeVal:false,    //短信通知状态值
        telephoneNoticVal:false,   //电话通知状态值
      },

      shortMessageNoticeData:{ //短信配置状态值
        alibabaCloudSMSVal: false, //阿里云短信状态值
        serialSMSVal: false, //串口短信状态值
        hostSMSVal: false, //主机短信状态值
        customVal: false //自定义通道状态值
      },

      emailNotificationNoticeData:{ //邮件通知配置状态值
        mailServerVal: false, //邮件服务器状态值
        mailSSLVal: false, //SSL
        mailVerificationVal: false, //验证
      },

      telephoneNoticeData:{ //电话通知配置状态
        hostPhoneVal: false, //主机电话状态
      },

      acoustoOpticNoticeData:{ //声光通知配置
        hostAcoustoOpticVal: false, //主机声光
      },

      voiceAlarmData: {   //声音告警状态值
        val:false,
      },

      extSystematic: {
        parentId: 0,
        code: "",
        name: "",
        val1: "",
        val2: "",
        ordinal: "",
        isDisplay: true,
        icon1: "",
        icon2: "",
        note: "",
        spare: "",
        manageable: true
      },

      //弹出窗
      title: '', //标题
      type: '',
      notificationConfigurationDialogVisible: false, //弹窗状态
      notificationConfigurationFunctionDialogVisible: false,

      // hostConfigurationNoticeVoice: false, //主机通知状态
      shortMessageNoticeVoice: false, //短信通知配置状态
      emailNotificationNoticeVoice: false, //邮件通知配置状态
      telephoneNoticeVoice: false, //电话通知配置状态
      acoustoOpticNoticeVoice: false, //声光通知配置状态
      voiceAlarmVoice: false, //声音告警配置状态

      tree: [], //空间树
      spaceList: [], //空间列表
      gatewayList:[], //主机列表
      noticeType: '', //通知主机类型

      shortMessageNoticeSpaceHostList:[],//短信通知空间主机数据集合
      shortMessageNoticeSpaceHostNameList:[],//短信通知空间主机数据集合
      shortMessageNoticeWholeSpace: false, //全选空间
      shortMessageNoticeGatewaySn: '', //主机

      telephoneNoticeSpaceHostList: [], //主机电话空间数据
      telephoneNoticeSpaceHostNameList:[],//电话通知空间主机数据集合
      telephoneNoticeWholeSpace: false, //全选空间
      telephoneNoticeGatewaySn: '', //主机

      acoustoOpticNoticeSpaceHostList: [], //主机声光空间数据
      acoustoOpticNoticeSpaceHostNameList: [],//声光通知空间主机数据集合
      acoustoOpticNoticeWholeSpace: false, //全选空间
      acoustoOpticNoticeGatewaySn: '', //主机

      spaceHostName: { ////通知空间主机
        spaceName: '', //通知空间名称
        hostName: '', //通知主机名称
      },

      width: '50vw',

      alarmNotification: {},
      alarmWechatNotification: { code: 'dcim_alarm_wechat_notification_url', name: '告警推送企业微信地址', val1: false, val2: '' },
      dialogData: {},
      dialogWechatData: {},
      receiveFormData: {},
      receiveWechatFormData: {},
    }
  },
  //初始化数据
  mounted() {
    this.overflow()
    this.getSpaceTreeData();
    this.getGetewayList();
    this.getNotificationConfiguration();
  },
  //初始化参数
  computed: {},
  methods: {
    getNotificationConfiguration: function () {
      let codes = ["notification_type", "aliyunNoteNotification", "serialNotification",
        "gatewayNoteNotification", "emailNotification", "gatewayPhoneNotification",
        "gatewaySoundLightNotification","customNotification","dcim_alarm_wechat_notification_url"];

      this.getSystematicByCodes();

      getSystematicByParentCodes(codes).then(res => {
        this.systemParamterData = res.data;
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].code === "aliyunNoteNotification") {
            this.alibaba_cloud_SMS = res.data[i];
          } else if (res.data[i].code === "alibaba_cloud_SMS_ID") {
            this.alibaba_cloud_SMS_ID = res.data[i];
          } else if (res.data[i].code === "alibaba_cloud_SMS_key") {
            this.alibaba_cloud_SMS_key = res.data[i];
          } else if (res.data[i].code === "serialNotification") {
            this.serial_SMS = res.data[i];
          } else if (res.data[i].code === "serial_SMS_COM") {
            this.serial_SMS_COM = res.data[i];
          } else if (res.data[i].code === "center_number") {
            this.center_number = res.data[i];
          } else if (res.data[i].code === "sending_number") {
            this.sending_number = res.data[i];
          } else if (res.data[i].code === "gatewayNoteNotification") {
            this.host_SMS = res.data[i];
            this.initializationGatewayNoticeList("gatewayNoteNotification", this.shortMessageNoticeSpaceHostNameList);
          } else if (res.data[i].code === "emailNotification") {
            this.mail_server = res.data[i];
          } else if (res.data[i].code === "mail_SMTP") {
            this.mail_SMTP = res.data[i];
          } else if (res.data[i].code === "mail_SSL") {
            this.mail_SSL = res.data[i];
          } else if (res.data[i].code === "mail_SSL_port") {
            this.mail_SSL_port = res.data[i];
          } else if (res.data[i].code === "mail_verification") {
            this.mail_verification = res.data[i];
          } else if (res.data[i].code === "mail_port") {
            this.mail_port = res.data[i];
          } else if (res.data[i].code === "mail_send_email") {
            this.mail_send_email = res.data[i];
          } else if (res.data[i].code === "mail_send_userName") {
            this.mail_send_userName = res.data[i];
          } else if (res.data[i].code === "mail_password") {
            this.mail_password = res.data[i];
          } else if (res.data[i].code === "gatewayPhoneNotification") {
            this.host_phone = res.data[i];
            this.initializationGatewayNoticeList("gatewayPhoneNotification", this.telephoneNoticeSpaceHostNameList);
          } else if (res.data[i].code === "gatewaySoundLightNotification") {
            this.host_acousto_optic = res.data[i];
            this.initializationGatewayNoticeList("gatewaySoundLightNotification", this.acoustoOpticNoticeSpaceHostNameList);
          } else if (res.data[i].code === "voiceWarningNotification") {
            this.voice_alarm = res.data[i];
          } else if(res.data[i].code === "customNotification"){
            this.custom_SMS = res.data[i];
          } else if(res.data[i].code === "custom_url"){
            this.custom_url = res.data[i];
          } else if(res.data[i].code === "custom_method"){
            this.custom_method = res.data[i];
          } else if(res.data[i].code === "custom_parameter"){
            this.custom_parameter = res.data[i];
          } else if(res.data[i].code === "custom_resultKey"){
            this.custom_resultKey = res.data[i];
          }else if(res.data[i].code === "custom_postRequestWay"){
            this.custom_postRequestWay = res.data[i];
          } else if(res.data[i].code === "custom_parameterFormat"){
            this.custom_parameterFormat = res.data[i];
          }
        }
      })
    },

    getSystematicByCodes() {
      getSystematicByCodes("dcim_alarm_notification_url").then(res => {
        this.alarmNotification = res.data[0]
        this.alarmNotification.val1 = (this.alarmNotification.val1 === 'true')
      })
      getSystematicByCodes("dcim_alarm_wechat_notification_url").then(res => {
        if (res.data && res.data[0]) {
          this.alarmWechatNotification = res.data[0]
          this.alarmWechatNotification.val1 = (this.alarmWechatNotification.val1 === 'true')
        } else {
          this.alarmWechatNotification = { code: 'dcim_alarm_wechat_notification_url', name: '告警推送企业微信地址', val1: false, val2: '' }
        }
      })
    },

    //编辑
    updateSystemParamter(row) {
      this.type = row;
      this.dialogData = this.alarmNotification;

      this.acoustoOpticNoticeVoice = false;
      this.telephoneNoticeVoice = false;
      this.emailNotificationNoticeVoice = false;
      this.shortMessageNoticeVoice = false;
      this.voiceAlarmVoice = false;

      if (row === 'gatewayNoteNotification') {
        this.width = '50vw';
        this.title = '编辑短信通知配置';
        this.noticeType = "gatewayNoteNotification";

        this.shortMessageNoticeSpaceHostList = [];
        this.getGatewayNoticeList("gatewayNoteNotification", this.shortMessageNoticeSpaceHostList);

        this.shortMessageNoticeVoice = true;
        this.edit_alibaba_cloud_SMS = JSON.parse(JSON.stringify(this.alibaba_cloud_SMS));
        this.edit_alibaba_cloud_SMS_ID = JSON.parse(JSON.stringify(this.alibaba_cloud_SMS_ID));
        this.edit_alibaba_cloud_SMS_key = JSON.parse(JSON.stringify(this.alibaba_cloud_SMS_key));
        this.edit_serial_SMS = JSON.parse(JSON.stringify(this.serial_SMS));
        this.edit_serial_SMS_COM = JSON.parse(JSON.stringify(this.serial_SMS_COM));
        this.edit_center_number = JSON.parse(JSON.stringify(this.center_number));
        this.edit_sending_number = JSON.parse(JSON.stringify(this.sending_number));
        this.edit_host_SMS = JSON.parse(JSON.stringify(this.host_SMS));

        this.edit_custom = JSON.parse(JSON.stringify(this.custom_SMS));
        this.edit_custom_url = JSON.parse(JSON.stringify(this.custom_url));
        this.edit_custom_method = JSON.parse(JSON.stringify(this.custom_method));
        this.edit_custom_parameter = JSON.parse(JSON.stringify(this.custom_parameter));
        this.edit_custom_resultKey = JSON.parse(JSON.stringify(this.custom_resultKey));
        this.edit_custom_postRequestWay = JSON.parse(JSON.stringify(this.custom_postRequestWay));
        this.edit_custom_parameterFormat = JSON.parse(JSON.stringify(this.custom_parameterFormat));

        if (this.edit_alibaba_cloud_SMS.val1 === 'true') {
          this.shortMessageNoticeData.alibabaCloudSMSVal = true;
        } else {
          this.shortMessageNoticeData.alibabaCloudSMSVal = false;
        }

        if (this.edit_serial_SMS.val1 === 'true') {
          this.shortMessageNoticeData.serialSMSVal = true;
        } else {
          this.shortMessageNoticeData.serialSMSVal = false;
        }

        if (this.edit_host_SMS.val1 === 'true') {
          this.shortMessageNoticeData.hostSMSVal = true;
        } else {
          this.shortMessageNoticeData.hostSMSVal = false;
        }

        if (this.edit_custom.val1 === 'true') {
          this.shortMessageNoticeData.customVal = true;
        } else {
          this.shortMessageNoticeData.customVal = false;
        }

        this.notificationConfigurationDialogVisible = true;
      } else if (row === "emailNotification") {
        this.width = '50vw';
        this.title = '编辑邮件通知配置';

        this.emailNotificationNoticeVoice = true;
        this.edit_mail_server = JSON.parse(JSON.stringify(this.mail_server));
        this.edit_mail_SMTP = JSON.parse(JSON.stringify(this.mail_SMTP));
        this.edit_mail_SSL = JSON.parse(JSON.stringify(this.mail_SSL));
        this.edit_mail_SSL_port = JSON.parse(JSON.stringify(this.mail_SSL_port));
        this.edit_mail_verification = JSON.parse(JSON.stringify(this.mail_verification));
        this.edit_mail_port = JSON.parse(JSON.stringify(this.mail_port));
        this.edit_mail_send_email = JSON.parse(JSON.stringify(this.mail_send_email));
        this.edit_mail_send_userName = JSON.parse(JSON.stringify(this.mail_send_userName));
        this.edit_mail_password = JSON.parse(JSON.stringify(this.mail_password));

        if (this.edit_mail_server.val1 === 'true') {
          this.emailNotificationNoticeData.mailServerVal = true;
        } else {
          this.emailNotificationNoticeData.mailServerVal = false;
        }

        if (this.edit_mail_SSL.val1 === 'true') {
          this.emailNotificationNoticeData.mailSSLVal = true;
        } else {
          this.emailNotificationNoticeData.mailSSLVal = false;
        }

        if (this.edit_mail_verification.val1 === 'true') {
          this.emailNotificationNoticeData.mailVerificationVal = true;
        } else {
          this.emailNotificationNoticeData.mailVerificationVal = false;
        }
        this.notificationConfigurationDialogVisible = true;
      } else if (row === "gatewayPhoneNotification") {
        this.width = '50vw';
        this.title = '编辑电话通知配置';
        this.noticeType = "gatewayPhoneNotification";

        this.telephoneNoticeSpaceHostList = [];
        this.getGatewayNoticeList("gatewayPhoneNotification", this.telephoneNoticeSpaceHostList);

        this.telephoneNoticeVoice = true;
        this.edit_host_phone = JSON.parse(JSON.stringify(this.host_phone));

        if (this.edit_host_phone.val1 === 'true') {
          this.telephoneNoticeData.hostPhoneVal = true;
        } else {
          this.telephoneNoticeData.hostPhoneVal = false;
        }
        this.notificationConfigurationFunctionDialogVisible = true;
      } else if (row === "gatewaySoundLightNotification") {
        this.width = '40vw';
        this.title = '编辑声光通知配置';
        this.type = "gatewaySoundLightNotification";
        this.noticeType = "gatewaySoundLightNotification";

        this.acoustoOpticNoticeSpaceHostList = [];
        this.getGatewayNoticeList("gatewaySoundLightNotification", this.acoustoOpticNoticeSpaceHostList);

        this.acoustoOpticNoticeVoice = true;
        this.edit_host_acousto_optic = JSON.parse(JSON.stringify(this.host_acousto_optic));

        if (this.edit_host_acousto_optic.val1 === 'true') {
          this.acoustoOpticNoticeData.hostAcoustoOpticVal = true;
        } else {
          this.acoustoOpticNoticeData.hostAcoustoOpticVal = false;
        }
        this.notificationConfigurationFunctionDialogVisible = true;
      } else if (row === 'voiceWarningNotification') {
        this.width = '30vw';
        this.title = '编辑声音告警配置';

        this.voiceAlarmVoice = true;
        this.edit_voice_alarm = JSON.parse(JSON.stringify(this.voice_alarm));

        if (this.edit_voice_alarm.val1 === 'true') {
          this.voiceAlarmData.val = true;
        } else {
          this.voiceAlarmData.val = false;
        }
        this.notificationConfigurationFunctionDialogVisible = true;
      } else if (row === 'alarmNotification') {
        this.width = '38vw';
        this.title = '编辑告警推送配置';
        this.notificationConfigurationFunctionDialogVisible = true;
      } else if (row === 'alarmWechatNotification') {
        this.width = '38vw';
        this.title = '编辑告警推送企业微信配置';
        this.dialogWechatData = this.alarmWechatNotification;
        this.notificationConfigurationFunctionDialogVisible = true;
      }

    },

    receiveData(data) {
      this.receiveFormData = data
    },

    receiveWechatData(data) {
      this.receiveWechatFormData = data
    },

    //保存
    commitSystematic() {
      if (this.type === 'alarmNotification') {
        saveOrUpdateSystematic([this.receiveFormData]).then(res => {
          if (res.code === 0) {
            this.$message.success("保存成功!")
          } else {
            this.$message.error("保存失败!")
          }
          this.notificationConfigurationFunctionDialogVisible = false;
          this.getSystematicByCodes();
        })
        return;
      }

      if (this.type === 'alarmWechatNotification') {
        saveOrUpdateSystematic([this.receiveWechatFormData]).then(res => {
          if (res.code === 0) {
            this.$message.success("保存成功!")
          } else {
            this.$message.error("保存失败!")
          }
          this.notificationConfigurationFunctionDialogVisible = false;
          this.getSystematicByCodes();
        })
        return;
      }


      let extSystematicList = [];
      preservationAndQuerySystematic(0, 'notification_type', '通知类型', this.extSystematic.val1, this.extSystematic.val2,
        this.extSystematic.icon1, this.extSystematic.icon2).then(res => {
        if (res.code == 0) {
          this.extSystematic.parentId = res.data.id;

          //保存父配置
          if (this.type == "gatewayNoteNotification") {
            //校验
              if (this.shortMessageNoticeData.alibabaCloudSMSVal){
                if(!this.$stringIsNotNullAndEmpty(this.edit_alibaba_cloud_SMS_ID.val1)){
                  this.$message({
                    message: '阿里云短信已开启，ID不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if (!this.$stringIsNotNullAndEmpty(this.edit_alibaba_cloud_SMS_key.val1)){
                  this.$message({
                    message: '阿里云短信已开启，密钥不能为空',
                    type: 'warning'
                  });
                  return;
                }
              }
              if (this.shortMessageNoticeData.serialSMSVal){
                if (!this.$stringIsNotNullAndEmpty(this.edit_serial_SMS_COM.val1)){
                  this.$message({
                    message: '串口短信已开启，COM口不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if (!this.$stringIsNotNullAndEmpty(this.edit_center_number.val1)){
                  this.$message({
                    message: '串口短信已开启，中心号码不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if (!this.$stringIsNotNullAndEmpty(this.edit_sending_number.val1)){
                  this.$message({
                    message: '串口短信已开启，发送号码不能为空',
                    type: 'warning'
                  });
                  return;
                }
              }

            if (this.shortMessageNoticeData.customVal){
              if (!this.$stringIsNotNullAndEmpty(this.edit_custom_url.val1)){
                this.$message({
                  message: '自定义通道已开启，通道地址不能为空',
                  type: 'warning'
                });
                return;
              }
              if (!this.$stringIsNotNullAndEmpty(this.edit_custom_method.val1)){
                this.$message({
                  message: '自定义通道已开启，请求方式不能为空',
                  type: 'warning'
                });
                return;
              }
              if (!this.$stringIsNotNullAndEmpty(this.edit_custom_parameter.val1)){
                this.$message({
                  message: '自定义通道已开启，固定参数不能为空',
                  type: 'warning'
                });
                return;
              }
              if (!this.$stringIsNotNullAndEmpty(this.edit_custom_resultKey.val1)){
                this.$message({
                  message: '自定义通道已开启，结果key不能为空',
                  type: 'warning'
                });
                return;
              }

              if (this.edit_custom_method =='POST' && !this.$stringIsNotNullAndEmpty(this.edit_custom_postRequestWay.val1)){
                this.$message({
                  message: '自定义请求方式为POST，请求类型不能为空',
                  type: 'warning'
                });
                return;
              }
            }

              if(this.shortMessageNoticeData.hostSMSVal){
                let gatewaySnState = false;
                if (this.shortMessageNoticeSpaceHostList.length > 0){
                  for (let i = 0; i < this.shortMessageNoticeSpaceHostList.length; i++) {
                    if (this.shortMessageNoticeSpaceHostList[i].gatewaySn === "") {
                      gatewaySnState = true;
                      break;
                    }
                  }
                }else{
                  gatewaySnState = true;
                }

                if (!this.$stringIsNotNullAndEmpty(this.shortMessageNoticeGatewaySn) && gatewaySnState) {
                  this.$message({
                    message: '主机短信已开启，请至少选择一个主机',
                    type: 'warning'
                  });
                  return;
                }
              }

              this.edit_alibaba_cloud_SMS.parentId = res.data.id;
              this.edit_alibaba_cloud_SMS.val1 = this.shortMessageNoticeData.alibabaCloudSMSVal;
              this.edit_serial_SMS.parentId = res.data.id;
              this.edit_serial_SMS.val1 = this.shortMessageNoticeData.serialSMSVal;
              this.edit_host_SMS.parentId = res.data.id;
              this.edit_host_SMS.val1 = this.shortMessageNoticeData.hostSMSVal;

              this.edit_custom.parentId = res.data.id;
              this.edit_custom.val1 = this.shortMessageNoticeData.customVal;

              console.info(this.shortMessageNoticeData);

              extSystematicList.push(this.edit_alibaba_cloud_SMS);
              extSystematicList.push(this.edit_serial_SMS);
              extSystematicList.push(this.edit_host_SMS);
              extSystematicList.push(this.edit_custom);
              this.preservationAndQuerySystematicList(extSystematicList);

            }else if (this.type == "emailNotification"){
              //校验
              if (this.emailNotificationNoticeData.mailServerVal){
                if(!this.$stringIsNotNullAndEmpty(this.edit_mail_SMTP.val1)){
                  this.$message({
                    message: '邮件服务器已开启，服务器地址不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if (this.emailNotificationNoticeData.mailSSLVal){
                  if (!this.$stringIsNotNullAndEmpty(this.edit_mail_SSL_port.val1)){
                    this.$message({
                      message: '邮件服务器、SLL已开启，SSL端口不能为空',
                      type: 'warning'
                    });
                    return;
                  }
                }
                if(!this.$stringIsNotNullAndEmpty(this.edit_mail_port.val1)){
                  this.$message({
                    message: '邮件服务器已开启，端口不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if(!this.$stringIsNotNullAndEmpty(this.edit_mail_send_email.val1)){
                  this.$message({
                    message: '邮件服务器已开启，发送邮箱不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if(!this.$stringIsNotNullAndEmpty(this.edit_mail_send_userName.val1)){
                  this.$message({
                    message: '邮件服务器已开启，发送用户名不能为空',
                    type: 'warning'
                  });
                  return;
                }
                if (this.emailNotificationNoticeData.mailVerificationVal){
                  if(!this.$stringIsNotNullAndEmpty(this.edit_mail_password.val1)){
                    this.$message({
                      message: '邮件服务器、验证密码已开启，密码不能为空',
                      type: 'warning'
                    });
                    return;
                  }
                }
              }

              let extSystematicList = [];
              this.edit_mail_server.parentId = res.data.id; //编辑邮件服务器
              this.edit_mail_server.val1 = this.emailNotificationNoticeData.mailServerVal;
              extSystematicList.push(this.edit_mail_server);
              this.preservationAndQuerySystematicList(extSystematicList);

            }else if (this.type == "gatewayPhoneNotification"){
              //校验
              if(this.telephoneNoticeData.hostPhoneVal) {
                let gatewaySnState = false;
                if (this.telephoneNoticeSpaceHostList.length > 0){
                  for (let i = 0; i < this.telephoneNoticeSpaceHostList.length; i++) {
                    if (this.telephoneNoticeSpaceHostList[i].gatewaySn === "") {
                      gatewaySnState = true;
                      break;
                    }
                  }
                }else{
                  gatewaySnState = true;
                }

                if (!this.$stringIsNotNullAndEmpty(this.telephoneNoticeGatewaySn) && gatewaySnState) {
                  this.$message({
                    message: '主机电话已开启，请至少选择一个主机',
                    type: 'warning'
                  });
                  return;
                }
              }

              this.edit_host_phone.parentId = res.data.id;
              this.edit_host_phone.val1 = this.telephoneNoticeData.hostPhoneVal;
              extSystematicList.push(this.edit_host_phone);
              this.preservationAndQuerySystematicList(extSystematicList);

            }else if (this.type == "gatewaySoundLightNotification"){
              if(this.acoustoOpticNoticeData.hostAcoustoOpticVal){
                let gatewaySnState = false;
                if (this.acoustoOpticNoticeSpaceHostList.length > 0){
                  for (let i = 0; i < this.acoustoOpticNoticeSpaceHostList.length; i++) {
                    if (this.acoustoOpticNoticeSpaceHostList[i].gatewaySn === "") {
                      gatewaySnState = true;
                      break;
                    }
                  }
                }else{
                  gatewaySnState = true;
                }

                if (!this.$stringIsNotNullAndEmpty(this.acoustoOpticNoticeGatewaySn) && gatewaySnState) {
                  this.$message({
                    message: '主机声光已开启，请至少选择一个主机',
                    type: 'warning'
                  });
                  return;
                }
              }

            this.edit_host_acousto_optic.parentId = res.data.id;
            this.edit_host_acousto_optic.val1 = this.acoustoOpticNoticeData.hostAcoustoOpticVal;
            extSystematicList.push(this.edit_host_acousto_optic);
            this.preservationAndQuerySystematicList(extSystematicList);
          } else if (this.type === "voiceWarningNotification") {
            this.edit_voice_alarm.parentId = res.data.id;
            this.edit_voice_alarm.val1 = this.voiceAlarmData.val;
            extSystematicList.push(this.edit_voice_alarm);
            this.preservationAndQuerySystematicList(extSystematicList);
          }
          }
      });

    },

    preservationAndQuerySystematicList(systematicList){
      let index = 1;
      for(var i = 0; i < systematicList.length; i++){
        preservationAndQuerySystematic(systematicList[i].parentId, systematicList[i].code, systematicList[i].name, systematicList[i].val1, systematicList[i].val2,
          this.extSystematic.icon1, this.extSystematic.icon2).then(res => {
          console.log("保存系统配置返回参数：", res);
          if (res.code == 0) {
            if (this.edit_alibaba_cloud_SMS.val1 && res.data.code == "aliyunNoteNotification") {
              this.edit_alibaba_cloud_SMS_ID.parentId = res.data.id;
              this.edit_alibaba_cloud_SMS_key.parentId = res.data.id;
            }else if (this.edit_serial_SMS.val1 && res.data.code == "serialNotification"){
              this.edit_serial_SMS_COM.parentId = res.data.id;
              this.edit_center_number.parentId = res.data.id;
              this.edit_sending_number.parentId = res.data.id;
            }else if (this.edit_mail_server.val1 && res.data.code == "emailNotification"){
              this.edit_mail_SMTP.parentId = res.data.id; //编辑邮件SMTP
              this.edit_mail_SSL.parentId = res.data.id; //编辑邮件SSL
              this.edit_mail_SSL_port.parentId = res.data.id; //编辑邮件SSL端口
              this.edit_mail_verification.parentId = res.data.id; //编辑邮件SMTP
              this.edit_mail_port.parentId = res.data.id; //编辑邮件端口
              this.edit_mail_send_email.parentId = res.data.id; //编辑发送邮箱
              this.edit_mail_send_userName.parentId = res.data.id; //编辑发送用户名
              this.edit_mail_password.parentId = res.data.id; //编辑密码

              this.edit_mail_SSL.val1 = this.emailNotificationNoticeData.mailSSLVal;
              this.edit_mail_verification.val1 = this.emailNotificationNoticeData.mailVerificationVal;
            } else if(this.edit_custom.val1 && res.data.code == "customNotification") {
              this.edit_custom_url.parentId = res.data.id;
              this.edit_custom_method.parentId = res.data.id;
              this.edit_custom_parameter.parentId = res.data.id;
              this.edit_custom_resultKey.parentId = res.data.id;
              this.edit_custom_parameterFormat.parentId = res.data.id;
              this.edit_custom_postRequestWay.parentId = res.data.id;
            }
          }
          if(index == systematicList.length){
            this.commitSon()
          }
          index++;
        });
      }

    },


    //保存子配置
    commitSon(){
      let extSystematicList = [];
      if (this.type == "gatewayNoteNotification") {
        if (this.edit_alibaba_cloud_SMS.val1){
          extSystematicList.push(this.edit_alibaba_cloud_SMS_ID);
          extSystematicList.push(this.edit_alibaba_cloud_SMS_key);
        }
        if (this.edit_serial_SMS.val1){
          extSystematicList.push(this.edit_serial_SMS_COM);
          extSystematicList.push(this.edit_center_number);
          extSystematicList.push(this.edit_sending_number);
        }
        if (this.edit_host_SMS.val1) { //开启保存主机空间数据
          this.saveSpaceHost(this.shortMessageNoticeWholeSpace, this.shortMessageNoticeGatewaySn, this.noticeType, this.shortMessageNoticeSpaceHostList);
        }
        if(this.edit_custom.val1){
          extSystematicList.push(this.edit_custom_url);
          extSystematicList.push(this.edit_custom_method);
          extSystematicList.push(this.edit_custom_parameter);
          extSystematicList.push(this.edit_custom_resultKey);
          extSystematicList.push(this.edit_custom_parameterFormat);
          extSystematicList.push(this.edit_custom_postRequestWay);
        }
      }else if (this.type == "emailNotification"){
        if (this.edit_mail_server.val1){
          extSystematicList.push(this.edit_mail_SMTP);
          extSystematicList.push(this.edit_mail_SSL);
          if (this.edit_mail_SSL.val1){
            extSystematicList.push(this.edit_mail_SSL_port);
          }

          extSystematicList.push(this.edit_mail_verification);
          if (this.edit_mail_verification.val1){
            extSystematicList.push(this.edit_mail_password);
          }
          extSystematicList.push(this.edit_mail_port);
          extSystematicList.push(this.edit_mail_send_email);
          extSystematicList.push(this.edit_mail_send_userName);
        }
      }else if (this.type == "gatewayPhoneNotification"){
        if (this.edit_host_phone.val1){ //开启保存主机空间数据
          this.saveSpaceHost(this.telephoneNoticeWholeSpace,this.telephoneNoticeGatewaySn,this.noticeType,this.telephoneNoticeSpaceHostList);
        }
      }else if (this.type == "gatewaySoundLightNotification"){
        if (this.edit_host_acousto_optic.val1){ //开启保存主机空间数据
          this.saveSpaceHost(this.acoustoOpticNoticeWholeSpace,this.acoustoOpticNoticeGatewaySn,this.noticeType,this.acoustoOpticNoticeSpaceHostList);
        }
      }
      console.log("请求参数：", extSystematicList);
      saveOrUpdateSystematic(extSystematicList).then(res => {
        console.log("保存系统子配置返回参数：", res);
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getNotificationConfiguration();
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }

        this.shortMessageNoticeSpaceHostList = [];//短信通知空间主机数据集合
        this.shortMessageNoticeSpaceHostNameList = [];//短信通知空间主机数据集合
        this.shortMessageNoticeWholeSpace = false; //全选空间
        this.shortMessageNoticeGatewaySn = ''; //主机

        this.telephoneNoticeSpaceHostList = []; //主机电话空间数据
        this.telephoneNoticeSpaceHostNameList = [];//电话通知空间主机数据集合
        this.telephoneNoticeWholeSpace = false; //全选空间
        this.telephoneNoticeGatewaySn = ''; //主机

        this.acoustoOpticNoticeSpaceHostList = []; //主机声光空间数据
        this.acoustoOpticNoticeSpaceHostNameList = [];//声光通知空间主机数据集合
        this.acoustoOpticNoticeWholeSpace = false; //全选空间
        this.acoustoOpticNoticeGatewaySn = ''; //主机

        this.notificationConfigurationDialogVisible = false;
        this.notificationConfigurationFunctionDialogVisible = false;
      })
    },

    //关闭
    closeDialog(){
      this.dialogData = {}
      this.dialogWechatData = {}
      this.notificationConfigurationDialogVisible = false;
      this.notificationConfigurationFunctionDialogVisible = false;

    },

    //空间树
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.tree = res.data;
          this.spaceList = getTreeHaveDisabled(res.data);
          console.log("空间",res.data);
        }
      });
    },

    //获取主机列表
    getGetewayList(){
      gatewayList().then(res =>{
        if (res.code === 0){
          this.gatewayList = res.data;
          console.log("主机列表",res.data);
        }
      });
    },

    //初始化通知配置空间主机
    initializationGatewayNoticeList(noticeType, spaceHostNameList){
      gatewayNoticeList(noticeType).then(res =>{
        if (res.code === 0){
          for (var i = 0; i < res.data.deviceGatewayNotices.length; i++) {
            this.spaceHostName = {};
            for (var j = 0; j < this.gatewayList.length; j++){
              if (res.data.deviceGatewayNotices[i].gatewaySn == this.gatewayList[j].snCode){
                this.spaceHostName.hostName = this.gatewayList[j].name;
                break;
              }
            }

            this.spaceHostName.inverse =  res.data.deviceGatewayNotices[i].inverse;

            for (var x = 0; x < res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn].length; x++){
              if (res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn][x] === "0"){
                if (this.spaceHostName.spaceName === undefined) {
                  this.spaceHostName.spaceName = "全部空间";
                } else {
                  this.spaceHostName.spaceName += "，全部空间";
                }
              }else{
                this.spaceNames({children:this.spaceList, id:'',label:''},res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn][x]);
              }
            }
            spaceHostNameList.push(this.spaceHostName)
          }
        }
      });
    },

    //编辑通知配置空间主机
    getGatewayNoticeList(noticeType, spaceHostList){
      gatewayNoticeList(noticeType).then(res =>{
        if (res.code === 0){
          for (var i = 0; i < res.data.deviceGatewayNotices.length; i++) {
            let spaceIds = [];
            for (var x = 0; x < res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn].length; x++){
              if (res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn][x] === "0"){
                if(noticeType === "gatewayNoteNotification"){
                  this.shortMessageNoticeWholeSpace = true;
                  this.shortMessageNoticeGatewaySn = res.data.deviceGatewayNotices[i].gatewaySn;
                }else if (noticeType === "gatewayPhoneNotification"){
                  this.telephoneNoticeWholeSpace = true;
                  this.telephoneNoticeGatewaySn = res.data.deviceGatewayNotices[i].gatewaySn;
                }else if (noticeType === "gatewaySoundLightNotification"){
                  this.acoustoOpticNoticeWholeSpace = true;
                  this.acoustoOpticNoticeGatewaySn = res.data.deviceGatewayNotices[i].gatewaySn;
                }
              }else{
                spaceIds.push(res.data.gatewaySnMap[res.data.deviceGatewayNotices[i].gatewaySn][x]);
              }
            }

            if (spaceIds.length > 0 ){
              let spaceHost = {
                gatewaySn: res.data.deviceGatewayNotices[i].gatewaySn,
                spaceIds: spaceIds,
                inverse: res.data.deviceGatewayNotices[i].inverse,
                type: noticeType,
              };
              spaceHostList.push(spaceHost);
            }
          }
        }
      });
    },

    //保存空间主机数据
    saveSpaceHost(wholeSpace,gatewaySn,noticeType,spaceHostList){
      let gatewayNoticesList = [];
      if(wholeSpace && gatewaySn != ""){
        let gatewayNotices = {
          gatewaySn: gatewaySn,
          spaceIds: [0],
          inverse: false,
          // 发送方式
          type: noticeType,
        };
        gatewayNoticesList.push(gatewayNotices);
      }

      for (var i = 0; i < spaceHostList.length; i++){
        if (spaceHostList[i].gatewaySn != "" && spaceHostList[i].spaceIds.length > 0){
          gatewayNoticesList.push(spaceHostList[i]);
        }
      }
      //保存主机空间数据
      saveGatewayNotice(gatewayNoticesList).then();
    },

    //获取主机对应的空间名
    spaceNames(node, spaceId){
      if(node.children) {
        for (var i = 0; i < node.children.length; i++) {
          if (node.children[i].value == spaceId) {
              if (this.spaceHostName.spaceName === undefined) {
                this.spaceHostName.spaceName = node.children[i].label;
              } else {
                this.spaceHostName.spaceName += "，" + node.children[i].label;
              }
            return;
          } else {
            this.spaceNames(node.children[i], spaceId);
          }
        }
      }
    },

    systemParamteDialogStyle(){
      let height = 300;
      if (this.type == "voiceWarningNotification"){
        height = 450;
      }else if (this.type == "gatewayNoteNotification"){
        height = 600;
      }
      return `
            height: `+height+`px`;
    },

  },
}
</script>

<style scoped>
</style>
